import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { IMAGE_BASE_URL } from "../../../constants/configuration";

export default function Attractions({
  details,
  attractionName,
  packageID,
}) {
  const [attractions, setAttractions] = useState([]);
  const [visibleCount, setVisibleCount] = useState(4);

  const data = details?.activity_attraction?.itinerary
  const visibleAttractions = attractions.slice(0, visibleCount);

  useEffect(() => {
    if (data) {
      const allAttractions = details?.activity_attraction?.itinerary?.flatMap(item => item.attraction) || [];
      setAttractions(allAttractions || []);
    }
  }, [data]);
  return (
    // console.log(attractions,'attractions'),
    <div className="attraction">
      <div className="container">
        <div className="header">
          <h2 className="title">ATTRACTIONS</h2>
        </div>
        <div className="row">
          {visibleAttractions?.map((ele, i) => {
            return (
              <div className="col-md-3" key={i}>
                <Link
                  to={`/attraction-details/${ele?.handle_key}/${packageID}`}
                >
                  <div className="atraction">
                    <div className="image">
                      <img
                        src={`${IMAGE_BASE_URL}attraction/${ele?.image}`}
                        alt={ele.image_alt}
                        className="w-100"
                      />
                    </div>
                    <div className="contents">
                      <h3>{ele?.title}</h3>
                      <p
                        className="attract"
                        dangerouslySetInnerHTML={{
                          __html: ele?.short_description,
                        }}
                      ></p>
                    </div>
                  </div>
                </Link>
              </div>
            );
          })}
        </div>
        <div className="view__more">
        {attractions.length > visibleCount && (
            <div className="view" onClick={() => setVisibleCount(prev => prev + 4)}>
               View More
              <img src="/assets/img/icons/btn-arrow.svg" alt="" />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
